module.exports = __webpack_public_path__ + "img/EmailLogo.25f75bfa.svg";